module.exports = __webpack_public_path__ + "media/images/flags/IE-0388f4e0e4b60516bcdf3d7221adea76.svg";